import { Entity, Field } from "typegraph";

@Entity({one: "", many: "tagSets"})
export default class TagSet {

	@Field()
	public id: string;

	@Field()
	public name: string;

}



// WEBPACK FOOTER //
// ./src/panels/recommended/userPreferences/entities/TagSet.ts